// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"1cc1913f53267a51","129":"6f19bad3e89af9d0","708":"386bd34beb4762a2","777":"fb11b4e509dcdfaf","822":"ab33fbb44dca5df2"}[chunkId] + ".js";
};